import Sidemenu from '../components/base/sidemenu';
import Privacy from '../components/privacy/PrivacyText';

export default function MapPage() {
    return (
        <div className='flex'>
            <Sidemenu />
            <Privacy />
        </div>
    );
}
